import * as angular from 'angular';

function onlyNum(): ng.IDirective {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope: ng.IScope, element: JQLite, attr: ng.IAttributes, ctrl: ng.IController) {
            scope.$watch(attr.showPassword, function (newVal: boolean, oldVal: boolean) {
                if (newVal) {
                    element.attr('type', 'text');
                } else {
                    element.attr('type', 'password');
                }
            });
        }
    };
}

angular
    .module('app.common')
    .directive('showPassword', onlyNum);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/showPassword.directive.ts